import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {DashboardComponent} from './dashboard/components/dashboard/dashboard.component';
import {HelpComponent} from './help/components/help/help.component';

import {PAGES_CONFIG} from './shared/constants/pages.constants';
import {AuthGuard} from './shared/guards/auth.guard';
import {ErrorPageComponent} from './error-page/components/error-page/error-page.component';
import {HasParamGuard} from './shared/guards/has-param.guard';
import {MsalGuard} from '@azure/msal-angular';
import {TranslationLoadedGuard} from './shared/guards/translation-loaded.guard';
import {VersionComponent} from './version/components/version/version.component';
import {ErrorAuthComponent} from './error-page/components/not-authorized/error-auth.component';
import { RootRedirectGuard } from './shared/guards/root-redirect.guard';
import {environment} from 'src/environments/environment';
import { FeaturesComponent } from './help/components/features/features.component';

const routes: Routes = [
  {
    path: PAGES_CONFIG.REQUESTS,
    loadChildren: () => import(/* webpackChunkName: "requests" */ './requests/requests.module').then(m => m.RequestsModule),
    canActivate: [MsalGuard, AuthGuard]
  },
  {
    path: PAGES_CONFIG.DASHBOARD,
    component: DashboardComponent,
    canActivate: [MsalGuard, AuthGuard]
  },
  {
    path: PAGES_CONFIG.REPORTS,
    loadChildren: () => import(/* webpackChunkName: "reports" */ './reports/reports.module').then(m => m.ReportsModule),
    canActivate: [MsalGuard, AuthGuard, TranslationLoadedGuard]
  },
  {
    path: PAGES_CONFIG.HELP,
    component: HelpComponent
  },
  {
    path: PAGES_CONFIG.VERSIONS,
    component: VersionComponent
  },
  {
    path: PAGES_CONFIG.ERROR,
    component: ErrorPageComponent,
    canActivate: [HasParamGuard],
    data: {
      requiredParams: ['error'],
      navigateFallback: `/`
    }
  },
  {
    path: PAGES_CONFIG.ERROR_AUTH,
    component: ErrorAuthComponent,
    canActivate: [HasParamGuard],
    data: {
      requiredParams: ['user'],
      navigateFallback: `/`
    }
  },
  {
    path: '',
    component: ErrorAuthComponent,
    canActivate: [
      MsalGuard,
      RootRedirectGuard
    ],
    pathMatch: 'full'
  },
  {
    path: PAGES_CONFIG.APPROVALS,
    loadChildren: () => import(/* webpackChunkName: "approvals" */ './approvals/approvals.module').then(m => m.ApprovalsModule),
    canActivate: [MsalGuard, AuthGuard, TranslationLoadedGuard]
  },
  ...(!environment.production
    ? [
        {
          path: 'features',
          component: FeaturesComponent
        }
      ]
    : [])
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {relativeLinkResolution: 'legacy'})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
